/**
 * 支付与订阅 API
 */
import api from './api';
import { PlanInfo, OrderInfo, SubscriptionStatus } from '../types';

export const paymentApi = {
  getPlans: () =>
    api.get<PlanInfo[]>('/api/payment/plans'),

  createOrder: (plan_id: string) =>
    api.post<OrderInfo>('/api/payment/orders', { plan_id }),

  getOrder: (id: number) =>
    api.get<OrderInfo>(`/api/payment/orders/${id}`),

  getSubscriptionStatus: () =>
    api.get<SubscriptionStatus>('/api/payment/subscription-status'),
};
